import { createContext } from '@lit/context'

/**
 * The API a [Combobox](/components/combobox/) shares with its declarative
 * `<nord-combobox-option>` / `<nord-combobox-group>` children so they can
 * register themselves as options (provide/inject), instead of the combobox
 * polling the DOM.
 */
export interface ComboboxRegistry {
  /** Register an option element as a selectable option. */
  add: (option: Element) => void
  /** Remove a previously-registered option element. */
  remove: (option: Element) => void
  /** Re-read the registered options (after an attribute/content/group change). */
  notify: () => void
}

/** Context the combobox provides to its option/group children. */
export const comboboxRegistryContext = createContext<ComboboxRegistry | undefined>(
  Symbol('nord-combobox-registry'),
)
